import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "../views/template/view.layout";
import Home from "../views/view.home";
import Profile from "../views/template/view.profile";

// --- ADMIN IMPORTS ---
import StudentList from "../views/admin/student/view.studentList";
import StudentCreate from "../views/admin/student/view.studentCreate";
import StudentUpdate from "../views/admin/student/view.studentUpdate";

import TeacherList from "../views/admin/teacher/view.teacherList";
import TeacherCreate from "../views/admin/teacher/view.teacherCreate";
import TeacherUpdate from "../views/admin/teacher/view.teacherUpdate";
import AffectTeacher from "../views/admin/teacher/view.affectTeacher";

import AdminList from "../views/admin/school_admin/view.adminList";
import AdminCreate from "../views/admin/school_admin/view.adminCreate";
import AdminUpdate from "../views/admin/school_admin/view.adminUpdate";

import MatiereList from "../views/admin/matiere/view.matiereList";
import MatiereCreate from "../views/admin/matiere/view.matiereCreate";
import MatiereUpdate from "../views/admin/matiere/view.matiereUpdate";

import FournitureList from "../views/admin/fourniture/view.fournitureList";
import FournitureCreate from "../views/admin/fourniture/view.fournitureCreate";
import FournitureUpdate from "../views/admin/fourniture/view.fournitureUpdate";

import InfoList from "../views/admin/info/view.infoList";
import InfoCreate from "../views/admin/info/view.infoCreate";
import SendNotification from "../views/admin/info/view.sendNotification";

import PlanningList from "../views/admin/planning/view.planningList";
import PlanningCreate from "../views/admin/planning/view.planningCreate";
import PlanningUpdate from "../views/admin/planning/view.planningUpdate";

import PubList from "../views/admin/pub/view.pubList";
import PubCreate from "../views/admin/pub/view.pubCreate";

import SalleList from "../views/admin/salle/view.salleList";
import SalleCreate from "../views/admin/salle/view.salleCreate";
import SalleUpdate from "../views/admin/salle/view.salleUpdate";

import ClasseList from "../views/admin/classe/view.classeList";
import ClasseCreate from "../views/admin/classe/view.classeCreate";
import ClasseUpdate from "../views/admin/classe/view.classeUpdate";

import PeriodList from "../views/admin/period/view.periodList";
import PeriodCreate from "../views/admin/period/view.periodCreate";
import PeriodUpdate from "../views/admin/period/view.periodUpdate";

import ChatList from "../views/admin/chat/view.chatList";
import ChatCreate from "../views/admin/chat/view.chatCreate";
import ChatConversation from "../views/admin/chat/view.chatConversation";

import FinanceList from "../views/admin/finance/view.financeList";

import AbsenceList from "../views/admin/absence/view.absenceList";
import AbsenceCreate from "../views/admin/absence/view.absenceCreate";

import EcoleAnneeList from "../views/admin/ecole_annee/view.ecoleAnnee";
import CoefficientList from "../views/admin/coefficient/view.coefficient";
import ExportUsers from "../views/admin/export/view.exportUsers";
import DeletionRequestList from "../views/admin/deletion_request/view.deletionRequestList";

// --- SUPER ADMIN IMPORTS ---
import SendGlobalNotification from "../views/superadmin/view.sendGlobalNotification";
import EcoleGlobalList from "../views/superadmin/view.ecoleGlobalList";
import AdminGlobalList from "../views/superadmin/view.adminGlobalList";
import AdminGlobalCreate from "../views/superadmin/view.adminGlobalCreate";
import AdminGlobalUpdate from "../views/superadmin/view.adminGlobalUpdate";
import EcoleForm from "../views/superadmin/ecole/view.ecoleForm";
import SchoolPlanView from "../views/superadmin/view.schoolPlan";
// --- ADMIN NEW FEATURES ---
import BulletinView from "../views/admin/period/view.bulletin";
import NotesBatchView from "../views/admin/student/view.notesBatch";
import NoteList from "../views/admin/student/view.noteList";
import BatchUpload from "../views/admin/batch/view.batchUpload";

// --- REUNIONS ---
import ReunionList from "../views/admin/reunion/view.reunionList";
import ReunionCreate from "../views/admin/reunion/view.reunionCreate";
import ReunionUpdate from "../views/admin/reunion/view.reunionUpdate";


const ProtectedRoute = ({ roleRequired, children }) => {
    const user = useSelector((state) => state.userReducer?.user);
    if (!user) return <Navigate to="/login" replace />;
    if (roleRequired && user.role !== roleRequired) {
        return <Navigate to="/" replace />;
    }
    return children;
};

export default function BasicRouting() {
    return (
        <Layout>
            <Routes>
                {/* COMMON ROUTES */}
                <Route path="/" element={<Home />} />
                <Route path="/profile" element={<Profile />} />

                {/* --- ADMIN ROUTES --- */}
                <Route path="/students" element={<ProtectedRoute roleRequired="ADMIN"><StudentList /></ProtectedRoute>} />
                <Route path="/students/create" element={<ProtectedRoute roleRequired="ADMIN"><StudentCreate /></ProtectedRoute>} />
                <Route path="/students/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><StudentUpdate /></ProtectedRoute>} />
                <Route path="/students/batch" element={<ProtectedRoute roleRequired="ADMIN"><BatchUpload role="ETUDIANT" /></ProtectedRoute>} />
                
                <Route path="/teachers" element={<ProtectedRoute roleRequired="ADMIN"><TeacherList /></ProtectedRoute>} />
                <Route path="/teachers/create" element={<ProtectedRoute roleRequired="ADMIN"><TeacherCreate /></ProtectedRoute>} />
                <Route path="/teachers/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><TeacherUpdate /></ProtectedRoute>} />
                <Route path="/teachers/affect" element={<ProtectedRoute roleRequired="ADMIN"><AffectTeacher /></ProtectedRoute>} />
                <Route path="/teachers/batch" element={<ProtectedRoute roleRequired="ADMIN"><BatchUpload role="PROFESSEUR" /></ProtectedRoute>} />

                <Route path="/admins" element={<ProtectedRoute roleRequired="ADMIN"><AdminList /></ProtectedRoute>} />
                <Route path="/admins/create" element={<ProtectedRoute roleRequired="ADMIN"><AdminCreate /></ProtectedRoute>} />
                <Route path="/admins/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><AdminUpdate /></ProtectedRoute>} />
                <Route path="/admins/batch" element={<ProtectedRoute roleRequired="ADMIN"><BatchUpload role="ADMIN" /></ProtectedRoute>} />

                <Route path="/matieres" element={<ProtectedRoute roleRequired="ADMIN"><MatiereList /></ProtectedRoute>} />
                <Route path="/matieres/create" element={<ProtectedRoute roleRequired="ADMIN"><MatiereCreate /></ProtectedRoute>} />
                <Route path="/matieres/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><MatiereUpdate /></ProtectedRoute>} />

                <Route path="/fournitures" element={<ProtectedRoute roleRequired="ADMIN"><FournitureList /></ProtectedRoute>} />
                <Route path="/fournitures/create" element={<ProtectedRoute roleRequired="ADMIN"><FournitureCreate /></ProtectedRoute>} />
                <Route path="/fournitures/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><FournitureUpdate /></ProtectedRoute>} />
                
                <Route path="/infos" element={<ProtectedRoute roleRequired="ADMIN"><InfoList /></ProtectedRoute>} />
                <Route path="/infos/create" element={<ProtectedRoute roleRequired="ADMIN"><InfoCreate /></ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute roleRequired="ADMIN"><SendNotification /></ProtectedRoute>} />
                
                <Route path="/plannings" element={<ProtectedRoute roleRequired="ADMIN"><PlanningList /></ProtectedRoute>} />
                <Route path="/plannings/create" element={<ProtectedRoute roleRequired="ADMIN"><PlanningCreate /></ProtectedRoute>} />
                <Route path="/plannings/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><PlanningUpdate /></ProtectedRoute>} />

                <Route path="/pubs" element={<ProtectedRoute roleRequired="ADMIN"><PubList /></ProtectedRoute>} />
                <Route path="/pubs/create" element={<ProtectedRoute roleRequired="ADMIN"><PubCreate /></ProtectedRoute>} />

                <Route path="/salles" element={<ProtectedRoute roleRequired="ADMIN"><SalleList /></ProtectedRoute>} />
                <Route path="/salles/create" element={<ProtectedRoute roleRequired="ADMIN"><SalleCreate /></ProtectedRoute>} />
                <Route path="/salles/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><SalleUpdate /></ProtectedRoute>} />

                <Route path="/classes" element={<ProtectedRoute roleRequired="ADMIN"><ClasseList /></ProtectedRoute>} />
                <Route path="/classes/create" element={<ProtectedRoute roleRequired="ADMIN"><ClasseCreate /></ProtectedRoute>} />
                <Route path="/classes/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><ClasseUpdate /></ProtectedRoute>} />

                <Route path="/periods" element={<ProtectedRoute roleRequired="ADMIN"><PeriodList /></ProtectedRoute>} />
                <Route path="/periods/create" element={<ProtectedRoute roleRequired="ADMIN"><PeriodCreate /></ProtectedRoute>} />
                <Route path="/period/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><PeriodUpdate /></ProtectedRoute>} />

                <Route path="/chats" element={<ProtectedRoute roleRequired="ADMIN"><ChatList /></ProtectedRoute>} />
                <Route path="/chats/create" element={<ProtectedRoute roleRequired="ADMIN"><ChatCreate /></ProtectedRoute>} />
                <Route path="/chats/view/:id" element={<ProtectedRoute roleRequired="ADMIN"><ChatConversation /></ProtectedRoute>} />

                <Route path="/finances" element={<ProtectedRoute roleRequired="ADMIN"><FinanceList /></ProtectedRoute>} />

                <Route path="/absences" element={<ProtectedRoute roleRequired="ADMIN"><AbsenceList /></ProtectedRoute>} />
                <Route path="/absences/create" element={<ProtectedRoute roleRequired="ADMIN"><AbsenceCreate /></ProtectedRoute>} />

                <Route path="/annees" element={<ProtectedRoute roleRequired="ADMIN"><EcoleAnneeList /></ProtectedRoute>} />
                <Route path="/coefficients" element={<ProtectedRoute roleRequired="ADMIN"><CoefficientList /></ProtectedRoute>} />
                
                <Route path="/export" element={<ProtectedRoute roleRequired="ADMIN"><ExportUsers /></ProtectedRoute>} />
                
                <Route path="/deletion-requests" element={<ProtectedRoute roleRequired="ADMIN"><DeletionRequestList /></ProtectedRoute>} />

                <Route path="/ecole" element={<ProtectedRoute roleRequired="ADMIN"><EcoleForm /></ProtectedRoute>} />

                {/* --- BULLETINS & NOTES --- */}
                <Route path="/bulletins" element={<ProtectedRoute roleRequired="ADMIN"><BulletinView /></ProtectedRoute>} />
                <Route path="/notes" element={<ProtectedRoute roleRequired="ADMIN"><NoteList /></ProtectedRoute>} />
                <Route path="/notes/batch" element={<ProtectedRoute roleRequired="ADMIN"><NotesBatchView /></ProtectedRoute>} />
                
                {/* --- REUNIONS --- */}
                <Route path="/reunions" element={<ProtectedRoute roleRequired="ADMIN"><ReunionList /></ProtectedRoute>} />
                <Route path="/reunions/create" element={<ProtectedRoute roleRequired="ADMIN"><ReunionCreate /></ProtectedRoute>} />
                <Route path="/reunions/update/:id" element={<ProtectedRoute roleRequired="ADMIN"><ReunionUpdate /></ProtectedRoute>} />
                
                {/* --- SUPER ADMIN ROUTES --- */}
                <Route path="/super-admin/ecoles" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><EcoleGlobalList /></ProtectedRoute>} />
                <Route path="/super-admin/ecoles/create" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><EcoleForm /></ProtectedRoute>} />
                <Route path="/super-admin/ecoles/edit/:id" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><EcoleForm /></ProtectedRoute>} />
                <Route path="/super-admin/ecoles/plan" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><SchoolPlanView /></ProtectedRoute>} />
                <Route path="/super-admin/admins" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><AdminGlobalList /></ProtectedRoute>} />
                <Route path="/super-admin/admins/create" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><AdminGlobalCreate /></ProtectedRoute>} />
                <Route path="/super-admin/admins/update/:id" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><AdminGlobalUpdate /></ProtectedRoute>} />
                <Route path="/super-admin/notifications" element={<ProtectedRoute roleRequired="SUPER_ADMIN"><SendGlobalNotification /></ProtectedRoute>} />

                <Route path="*" element={<Home />} /> 
            </Routes>
        </Layout>
    )
}
